module.exports = "<section class=\"custom-container\">\n  <div class=\"zeo-logo\">\n      <img class=\"zeotap-img\" src=\"./assets/img/zeotapLogo.png\" />\n  </div>\n  <section class=\"heading zui-boldtext\">{{TEXT.custom[this.heading]['heading']}}</section>\n  <section class=\"primary-desc zui-content\">{{TEXT.custom[this.heading]['primaryDesc']}}</section>\n  <section class=\"secondary-desc zui-content\">{{TEXT.custom[this.heading]['secondaryDesc']}}</section>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/custom-screen/custom-screen.component.html
// module id = ./src/app/containers/custom-screen/custom-screen.component.html
// module chunks = main